import {
    Component,
    Input,
    ContentChild,
    TemplateRef,
    AfterContentInit,
    ViewChild,
    ElementRef,
    Output, EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TranslocoModule } from '@jsverse/transloco';
import { StripHtmlPipe } from '@client/app/shared-modules/pipes/strip-html.pipe';

@Component({
    selector: 'mon-page-layout',
    templateUrl: './page-layout.component.html',
    styleUrls: ['./page-layout.component.scss'],
    standalone: true,
    imports: [CommonModule, ButtonModule, TranslocoModule, StripHtmlPipe],
})
export class PageLayoutComponent implements AfterContentInit {
    @Input() header?: string;
    @Input() subheader?: string;
    @Input() showBackButton: boolean = false;
    @Input() backButtonAriaLabel?: string;
    @Input() formLayout: 'none' | 'single-column' = 'none';

    @Output() backClick = new EventEmitter<void>();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @ContentChild('headerContent', { read: TemplateRef }) headerContentRef?: TemplateRef<any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @ContentChild('subheaderContent', { read: TemplateRef }) subheaderContentRef?: TemplateRef<any>;
    @ViewChild('pageContainer', { read: ElementRef }) pageContainer?: ElementRef<HTMLElement>;

    hasHeaderContent = false;
    hasSubheaderContent = false;

    ngAfterContentInit (): void {
        this.hasHeaderContent = !!this.headerContentRef;
        this.hasSubheaderContent = !!this.subheaderContentRef;
    }

    onBackClick (): void {
        this.backClick.emit();
    }

    scrollToTop (): void {
        if (this.pageContainer?.nativeElement) {
            this.pageContainer.nativeElement.scrollIntoView({
                block: 'start',
            });
        }
    }
}
